<template>
    <v-dialog v-model="dialog" persistent content-class="modal-dialog">
        <v-card class="modal-adaptive">
            <div class="common-text text-center mb-2">
                {{waitingTitle}}
            </div>
            <v-flex xs12>
                <v-text-field
                    v-model="name"
                    placeholder="Введите название номера"
                    class="input-form-grey"
                    :error="error"
                    :error-messages="errorMessage"
                    @change="deleteError"
                    :class="{'mb-6': error}"
                ></v-text-field>
            </v-flex>
            <v-flex class="modal-row d-flex justify-end">
                <v-btn class="btn-grey main-text" @click="cancel">
                    Отмена
                </v-btn>
                <v-btn class="btn-gradient main-text" @click="addRoom" :disabled="!disabled">
                    Добавить
                </v-btn>
            </v-flex>
        </v-card>
        <ModalWaiting ref="modalWaiting" :title="waitingTitle"></ModalWaiting>
    </v-dialog>
</template>

<script>
import ModalWaiting from "@/components/modals/ModalWaiting";

export default {
    name: "ModalAddRoom",
    components: {ModalWaiting},
    props: {
        floor: {
            type: Number,
        },
        hotel: {
            type: String,
        },
        room: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
            name: null,
            error: null,
            errorMessage: null,
        }
    },
    created() {
        if (this.room) {
            this.name = JSON.parse(JSON.stringify(this.room.name));
        }
    },
    computed: {
        disabled() {
            return this.name;
        },
        waitingTitle() {
            if (this.room) {
                return "Редактирование номера";
            } else {
                return "Добавление номера";
            }
        },
    },
    watch: {
        room(val) {
            if (val) {
                this.name = JSON.parse(JSON.stringify(this.room.name));
            }
        },
    },
    methods: {
        open() {
            this.dialog = true;
        },
        close() {
            this.dialog = false;
        },
        cancel() {
            this.name = null;
            this.errorMessage = null;
            this.error = false;
            this.$emit("close");
        },
        addRoom() {
            this.$refs.modalWaiting.open();
            this.dialog = false;
            let url = "";
            let method = "post";
            if (this.room) {
                url = this.room.uid + "/";
                method = "patch";
            }
            this.$http[method]('/hotels/hotel-admin/rooms/' + url,
                {
                    name: this.name,
                    floor: this.room ? this.room.floor : this.floor,
                    hotel: this.room ? this.room.hotel.uid : this.hotel,
                })
                .then(() => {
                    this.$refs.modalWaiting.close();
                    this.cancel();
                })
                .catch((error) => {
                    this.$refs.modalWaiting.close();
                    console.log(error);
                    this.errorMessage = "Ошибка добавления";
                    this.error = true;
                    this.dialog = true;
                });
        },
        deleteError() {
            this.errorMessage = null;
            this.error = false;
        },
    }

}
</script>

<style lang="scss" scoped>
.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
    margin-right: 10px;
}

.btn-gradient.v-btn {
    max-width: 165px;
}
</style>